// extracted by mini-css-extract-plugin
module.exports = {"container":"Wrapper_container__29yWl","content":"Wrapper_content__3VoS2","main":"Wrapper_main__aNJDj"};